import styled from 'styled-components';
import { Button, Divider } from 'antd';

export const StyledDivider = styled(Divider)`
  margin: 8px 0;
`;

export const MenuActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 4px;
`;

export const SecondaryTextButton = styled(Button)`
  color: var(--text-color-secondary);
`;
